/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Hero_TitleInputs */

const en_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free. Go sovereign when you're ready.`)
};

const es_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza gratis. Pasa a Sovereign cuando estés listo.`)
};

const fr_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencez gratuitement. Passez au niveau Sovereign quand vous êtes prêt.`)
};

const de_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos starten. Auf Sovereign wechseln, wenn du bereit bist.`)
};

const ja_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料で開始。準備ができたらSovereignへ。`)
};

const zh_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费起步。准备就绪后即可升级至 Sovereign。`)
};

const ar_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ مجانًا. انتقل إلى Sovereign عندما تكون مستعدًا.`)
};

const id_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai gratis. Beralih ke Sovereign kapan pun Anda siap.`)
};

const it_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia gratis. Passa a Sovereign quando sei pronto.`)
};

const ru_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начните бесплатно. Переходите на Sovereign, когда будете готовы.`)
};

const pt_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece de graça. Seja Sovereign quando estiver pronto.`)
};

const ko_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료로 시작하세요. 준비가 되면 Sovereign으로 전환하세요.`)
};

/**
* | output |
* | --- |
* | "Start free. Go sovereign when you're ready." |
*
* @param {Pricing_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_hero_title = /** @type {((inputs?: Pricing_Hero_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Hero_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_hero_title(inputs)
	if (locale === "es") return es_pricing_hero_title(inputs)
	if (locale === "fr") return fr_pricing_hero_title(inputs)
	if (locale === "de") return de_pricing_hero_title(inputs)
	if (locale === "ja") return ja_pricing_hero_title(inputs)
	if (locale === "zh") return zh_pricing_hero_title(inputs)
	if (locale === "ar") return ar_pricing_hero_title(inputs)
	if (locale === "id") return id_pricing_hero_title(inputs)
	if (locale === "it") return it_pricing_hero_title(inputs)
	if (locale === "ru") return ru_pricing_hero_title(inputs)
	if (locale === "pt") return pt_pricing_hero_title(inputs)
	return ko_pricing_hero_title(inputs)
});